import React from 'react';
import moment from 'moment';

import { MaskRestrictedText } from '_src/components';

export default [
  {
    title: 'Code',
    dataIndex: 'code',
    width: 100
  },
  {
    title: 'First Name',
    dataIndex: 'firstName',
    width: 120,
    sorter: true
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
    width: 120,
    sorter: true
  },
  {
    title: 'Email',
    dataIndex: 'email',
    width: 270,
    sorter: true,
    render: (_, { email }) => (
      <div style={{ whiteSpace: 'break-spaces' }}>
        <MaskRestrictedText text={email} />
      </div>
    )
  },
  {
    title: 'Training School',
    dataIndex: 'schoolName',
    width: 170,
    render: (_, { schoolName }) => <div style={{ whiteSpace: 'break-spaces' }}>{schoolName}</div>
  },
  {
    title: 'City and State of Training',
    dataIndex: 'schoolLocation',
    width: 200,
    render: (_, { schoolLocation }) => (
      <div style={{ whiteSpace: 'break-spaces' }}>{schoolLocation}</div>
    )
  },
  {
    title: 'Scoring Site',
    dataIndex: 'branchName',
    width: 200,
    render: (_, { branchName }) => (
      <div style={{ whiteSpace: 'break-spaces' }}>{branchName ? `${branchName} Yard` : ''}</div>
    )
  },
  {
    title: 'Employers',
    key: 'employer',
    width: 150,
    render: (_, { employer }) => (
      <div style={{ maxWidth: 150, whiteSpace: 'break-spaces' }}>{employer}</div>
    )
  },
  {
    title: 'Testing Date',
    key: 'testing_date',
    width: 120,
    dataIndex: 'testingDate',
    render: (_, { testingDate }) =>
      testingDate ? moment(testingDate).parseZone().format('MM/DD/YYYY') : '',
    sorter: true
  },
  {
    title: 'Instructor First Name',
    dataIndex: 'instructorFirstName',
    width: 120,
    sorter: true
  },
  {
    title: 'Instructor Last Name',
    dataIndex: 'instructorLastName',
    width: 120,
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    filters: [
      { text: 'Successful', value: 'Successful' },
      { text: 'Incomplete', value: 'Incomplete' },
      { text: 'N/A Performance', value: 'n_a_performance' }
    ]
  },
  {
    title: 'Incomplete Reason',
    dataIndex: 'incompleteReason',
    width: 200,
    render: (_, { incompleteReason }) => (
      <div style={{ maxWidth: 200, whiteSpace: 'break-spaces' }}>{incompleteReason}</div>
    ),
    sorter: true
  },
  {
    title: 'Truck Class',
    dataIndex: 'truckClass',
    width: 110
  },
  {
    title: 'Score',
    dataIndex: 'score',
    sorter: true,
    width: 110
  },
  {
    title: 'Sections',
    children: [
      {
        title: 'Attention / Signaling',
        children: [
          {
            title: 'Score',
            key: 'attention_signaling_score',
            width: 100,
            render: (_, { sections }) => sections.attentionSignaling
          },
          {
            title: 'Notes',
            key: 'attention_signaling_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.attentionSignaling
          }
        ]
      },
      {
        title: 'Inspection / Safety',
        children: [
          {
            title: 'Score',
            key: 'inspection_safety_score',
            width: 100,
            render: (_, { sections }) => sections.inspectionSafety
          },
          {
            title: 'Notes',
            key: 'inspection_safety_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.inspectionSafety
          }
        ]
      },
      {
        title: 'Parking / Backing',
        children: [
          {
            title: 'Score',
            key: 'parking_docking_backing_score',
            width: 100,
            render: (_, { sections }) => sections.parkingDockingBacking
          },
          {
            title: 'Notes',
            key: 'parking_docking_backing_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.parkingBacking
          }
        ]
      },
      {
        title: 'Shifting',
        children: [
          {
            title: 'Score',
            key: 'shifting_score',
            width: 100,
            render: (_, { sections }) => sections.shifting
          },
          {
            title: 'Notes',
            key: 'shifting_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.shifting
          }
        ]
      },
      {
        title: 'Soft Skills',
        children: [
          {
            title: 'Score',
            key: 'soft_skills_score',
            width: 100,
            render: (_, { sections }) => sections.softSkills
          },
          {
            title: 'Notes',
            key: 'soft_skills_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.softSkills
          }
        ]
      },
      {
        title: 'Accelerating / Stopping',
        children: [
          {
            title: 'Score',
            key: 'speed_stopping_accelerating_score',
            width: 100,
            render: (_, { sections }) => sections.speedStoppingAccelerating
          },
          {
            title: 'Notes',
            key: 'speed_stopping_accelerating_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.acceleratingStopping
          }
        ]
      },
      {
        title: 'Maneuvering',
        children: [
          {
            title: 'Score',
            key: 'turns_score',
            width: 100,
            render: (_, { sections }) => sections.turns
          },
          {
            title: 'Notes',
            key: 'turns_notes',
            width: 200,
            render: (_, { sectionNotes }) => sectionNotes?.maneuvering
          }
        ]
      }
    ]
  },
  {
    title: 'Feedback Notes',
    key: 'feedback_notes',
    width: 200,
    render: (_, { feedbackNotes }) => (
      <div style={{ maxWidth: 200, whiteSpace: 'break-spaces' }}>{feedbackNotes}</div>
    )
  }
];
